import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { api } from './api-client';
import type { EmployeeDto } from './types';

export function useMyEmployee(options?: Partial<UseQueryOptions<EmployeeDto>>) {
  return useQuery({
    queryKey: ['employees', 'me'],
    queryFn: () => api.get<EmployeeDto>('/v1/employees/me'),
    ...options,
  });
}
